module.exports = "../images/icons/arrow-left-empty.svg";